import { CalendarDaysIcon } from "@heroicons/react/24/outline";
import { format } from "date-fns";
import { formatDateString } from "../../helpers/general";

const ROLE_TONES: Record<string, { bg: string; color: string }> = {
  partner: { bg: "#fff1e7", color: "#ff7722" },
  admin: { bg: "#f3e8ff", color: "#7e3af2" },
  driver: { bg: "#e8f6ff", color: "#1d7fb3" },
  user: { bg: "#eaf8ef", color: "#239b4a" },
};
const DEFAULT_TONE = { bg: "#f1f1f1", color: "#555" };

export function RoleTag({ label }: { label?: string }) {
  if (!label) return null;
  const tone = ROLE_TONES[label.toLowerCase()] ?? DEFAULT_TONE;
  return (
    <span
      className="badge rounded-pill px-3 py-2 text-uppercase"
      style={{
        background: tone.bg,
        color: tone.color,
        fontSize: 11,
        letterSpacing: ".04em",
      }}
    >
      {label}
    </span>
  );
}

export default function UserDetailHeader({
  userData,
  blocked,
  loading,
  onBlock,
  onUnblock,
}: {
  userData?: User;
  blocked: boolean;
  loading: boolean;
  onBlock: () => void;
  onUnblock: () => void;
}) {
  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 bg-white rounded-4 shadow-sm p-3 my-3 w-100">
      <div className="d-flex align-items-center gap-3 min-w-0">
        <img
          src={
            (userData?.profilePicture as string) ??
            `https://ui-avatars.com/api/?name=${encodeURIComponent(userData?.fullName ?? "")}`
          }
          alt=""
          width={56}
          height={56}
          className="rounded-circle border border-2 border-danger object-fit-cover bg-white flex-shrink-0"
        />
        <div className="min-w-0">
          <div className="d-flex flex-wrap align-items-center gap-2">
            <h5 className="fs-4 fw-bold text-capitalize mb-0">
              {userData?.fullName}
            </h5>
            <RoleTag label={userData?.role?.label} />
            {blocked && (
              <span className="badge rounded-pill bg-danger px-3 py-2">
                Bloqué
              </span>
            )}
          </div>
          {userData?.createdAt && (
            <p className="d-flex align-items-center gap-1 text-sm text-secondary mb-0 mt-1">
              <CalendarDaysIcon width={14} height={14} />
              Inscrit le {formatDateString(userData.createdAt)} à{" "}
              {format(new Date(userData.createdAt), "HH:mm")}
            </p>
          )}
        </div>
      </div>

      <button
        type="button"
        className={`btn rounded-pill py-2 px-4 ${
          blocked
            ? "btn-outline-danger"
            : "btn-danger text-white shadow-primary"
        }`}
        onClick={blocked ? onUnblock : onBlock}
        disabled={loading}
      >
        {blocked ? "Débloquer" : "Bloquer"}
      </button>
    </div>
  );
}
